import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/branding';
import { ResultState } from '@rootCommon/types/common';
import { DashboardBranding, LogoRepositories } from '@rootCommon/types/branding';

type Action = ActionType<typeof actions>;
export type DashboardBrandingState = ResultState<DashboardBranding | null>;

const initState: DashboardBrandingState = {
  data: null,
  loading: false,
  error: null,
};

export const dashboardBrandingReducer = (state = initState, action: Action): DashboardBrandingState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchDashboardBranding.request):
      return { ...state, loading: true };
    case getType(actions.fetchDashboardBranding.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchDashboardBranding.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateDashboardBranding.request):
      return { ...state, loading: true };
    case getType(actions.updateDashboardBranding.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateDashboardBranding.failure):
      return { ...state, loading: false, error: action.payload };

      // delete
    case getType(actions.deleteDashboardBranding):
      return {
        ...state,
        loading: false,
        data: state.data ? { ...state.data, [LogoRepositories.primaryLogoFileId]: null } : null,
      };

    default:
      return state;
  }
};

export default dashboardBrandingReducer;
